import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDevices } from '../services/deviceService';

function useDevices() {
  const {
    data: devices = [],
    isLoading,
    error
  } = useQuery(
    ['devices'],
    getDevices,
    {
      staleTime: 300_000,
      cacheTime: 600_000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchInterval: 300_000,
      refetchIntervalInBackground: true
    }
  );

  const devicesWithAnemometer = useMemo(
    () => devices.filter(d => d.hasAnemometer),
    [devices]
  );

  return {
    devices,
    devicesWithAnemometer,
    loading: isLoading,
    error
  };
}

export default useDevices;
